
<script>
import PieChart from "../reporting/pieChart.vue";


export default {

  components: { PieChart},

  props: {

    ageRangeRate: {
        type: Object,
        default: () => null
        }
    },

 
};
</script>

<template>

    <div class="card h-100" v-if="ageRangeRate && ageRangeRate.values && ageRangeRate.labels " style="border:1px solid #ddd;">
        <div class="card-body h-100"> 

            <h4 class="text-dark text-uppercase font-weight-bold">{{$t('campaign.card.ageRangeRate') }}</h4>


         <PieChart :data="ageRangeRate.values" :labels="ageRangeRate.labels"  />
        </div> 
    </div>

</template>